import { RoundupDriverGroupEnum } from '@repo/contracts/marketplace/offers/enums';
import type { AllDrivers } from '../../types';

export type DriverRows = {
  drivers: (keyof AllDrivers)[];
  desktop: {
    firstRow: (keyof AllDrivers)[];
    secondRow: (keyof AllDrivers)[];
  };
  mobile: {
    rowWideDrivers: (keyof AllDrivers)[];
  };
};

export const DRIVER_ROW_MAP: Record<RoundupDriverGroupEnum, DriverRows> = {
  [RoundupDriverGroupEnum.BalanceTransfer]: {
    drivers: [
      'balanceTransferIntroAPR',
      'purchaseIntroAPR',
      'regularAPR',
      'annualFee',
      'rewardsRate',
      'introOffer',
      'recommendedCreditScore',
    ],
    desktop: {
      firstRow: ['balanceTransferIntroAPR', 'purchaseIntroAPR', 'regularAPR'],
      secondRow: ['annualFee', 'rewardsRate', 'introOffer', 'recommendedCreditScore'],
    },
    mobile: {
      rowWideDrivers: [
        'balanceTransferIntroAPR',
        'purchaseIntroAPR',
        'regularAPR',
        'recommendedCreditScore',
      ],
    },
  },
  [RoundupDriverGroupEnum.Default]: {
    drivers: [
      'purchaseIntroAPR',
      'balanceTransferIntroAPR',
      'regularAPR',
      'annualFee',
      'rewardsRate',
      'introOffer',
      'recommendedCreditScore',
    ],
    desktop: {
      firstRow: ['purchaseIntroAPR', 'balanceTransferIntroAPR', 'regularAPR'],
      secondRow: ['annualFee', 'rewardsRate', 'introOffer', 'recommendedCreditScore'],
    },
    mobile: {
      rowWideDrivers: [
        'balanceTransferIntroAPR',
        'purchaseIntroAPR',
        'regularAPR',
        'recommendedCreditScore',
      ],
    },
  },
  [RoundupDriverGroupEnum.Rewards]: {
    drivers: [
      'annualFee',
      'rewardsRate',
      'introOffer',
      'recommendedCreditScore',
      'purchaseIntroAPR',
      'balanceTransferIntroAPR',
      'regularAPR',
    ],
    desktop: {
      firstRow: ['annualFee', 'rewardsRate', 'introOffer', 'recommendedCreditScore'],
      secondRow: ['purchaseIntroAPR', 'balanceTransferIntroAPR', 'regularAPR'],
    },
    mobile: {
      rowWideDrivers: [
        'purchaseIntroAPR',
        'balanceTransferIntroAPR',
        'regularAPR',
        'recommendedCreditScore',
        'introOffer',
      ],
    },
  },
  [RoundupDriverGroupEnum.Subprime]: {
    drivers: [
      'annualFee',
      'minimumDeposit',
      'recommendedCreditScore',
      'regularAPR',
      'balanceTransferIntroAPR',
      'rewardsRate',
      'introOffer',
    ],
    desktop: {
      firstRow: ['annualFee', 'minimumDeposit', 'recommendedCreditScore'],
      secondRow: ['regularAPR', 'balanceTransferIntroAPR', 'rewardsRate', 'introOffer'],
    },
    mobile: {
      rowWideDrivers: ['recommendedCreditScore', 'regularAPR', 'balanceTransferIntroAPR'],
    },
  },
} as const;
